import ApiService from '../ApiService';
import AuthService from './AuthService';
import SocieteServices from './SocieteServices';


class OffreService {
  

  static savePropaltoDB(data) {

    return ApiService.post("offre/savePropal",data,AuthService.getToken())
    .then(res=>{
        if (res.status===200){ return res.id;}
        if (res.status===500){return "existdeja";}
        else{return "error";} 
    })
    .catch(err=>{
        throw err
    })
  }
  static savePsasptoDB(data) {

    return ApiService.post("offre/saveSaSp",data,AuthService.getToken())
    .then(res=>{
        if (res.status===200){ return res.id;}
        if (res.status===500){return "existdeja";}
        else{return "error";} 
    })
    .catch(err=>{
        throw err
    })
  }

  static getAllOffre(){
    return ApiService.post("offre/getAll",{societeID:SocieteServices.getSociete()},AuthService.getToken())
    .then(res=>{return res;})
    .catch(error=>{
      throw error;
    })
  }
  
  static getallToBdc(){
    return ApiService.post("offre/alltoBDC",{societeID:SocieteServices.getSociete()},AuthService.getToken())
    .then(res=>{return res;})
    .catch(error=>{
      throw error;
    })
  }
 

  static updateData(data) {
    return ApiService.put("product/update",data,AuthService.getToken())
    .then(res=>{
        if (res.status===200){return data.idProduct;}
        else{return "error";} 
       })
    .catch(err=>
        {
          console.log(err)
            throw err
        })
  }
  
  static deleteOffre(id_delete){
    return ApiService.post("offre/delete",{id:id_delete},AuthService.getToken())
    .then(res=>{
      if (res.status===200)return true 
      else return false
    })
    .catch(error=>{
      throw error;
    })
  }
  static getByIDOffreGuest(id){
    return ApiService.post("offre/getByIDGuest",{id:id})
    .then(res=>{
      return res;
    })
    .catch(error=>{
      throw error;
    })
  }
  static Guestupdateisaccepted(id,isaccepted) {
    return ApiService.put("offre/updateisaccepted",{id:id,isaccepted:isaccepted})
    .then(res=>{
        if (res.status===200){return "ok"}
        else{return "error";} 
       })
    .catch(err=>
        {
          console.log(err)
            throw err
        })
  }
  
  static getByID(id){
    return ApiService.post("offre/getByID",{id:id},AuthService.getToken())
    .then(res=>{
      return res;
    })
    .catch(error=>{
      throw error;
    })
  }
  
}

export default OffreService;


